<template>
    <div class="sr-input-valid-indicator">
        <SrIcon v-if="isValid" icon="check-mark" size="xs" />
    </div>
</template>

<script>
import SrIcon from '../SrIcon/SrIcon';

export default {
    name: 'SrInputValidIndicator',
    components: {
        SrIcon,
    },
    props: {
        isValid: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
